import { sideTabSchema } from "@/Routes/sidebar.utility";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

type TSideHrefProps = React.ComponentPropsWithoutRef<"a"> & {
  isActive: boolean;
  tabData?: sideTabSchema | null;
  hrefTo?: string;
  isTabOpen?: boolean;
  expandSidebar?: boolean;
};
function SideHref({
  hrefTo,
  tabData,
  isActive,
  isTabOpen,
  expandSidebar,
  ...rest
}: TSideHrefProps) {
  const tabRef = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    if (isActive && tabRef.current) {
      tabRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [isActive]);

  // const ellipseCount = tabData?.subTabs?.length ? 15 : 17;
  if (tabData?.code === "all-segments") {
    return <></>;
  }

  return (
    <Link
      to={hrefTo || window.location.href}
      {...rest}
      ref={tabRef}
      data-active={isActive}
      type="button"
      className={`group w-full flex items-center justify-between 
      min-h-8 gap-2 px-1.5 rounded-lg transition-all duration-150 hover:bg-white hover:text-primary outline-none 
       data-[active=true]:bg-primary data-[active=true]:text-white data-[active=true]:shadow-lg text-body ${rest.className}`}
    >
      <div className="flex h-8 items-center gap-2">
        {tabData?.icon && (
          <span
            data-active={isActive}
            className="h-5 w-5 text-primary data-[active=true]:text-white"
          >
            {tabData?.icon}
          </span>
        )}
        {expandSidebar && (
          <span className="text-sm font-semibold text-nowrap ">
            {stringUtility.addEllipsisAtEnd(String(tabData?.name), 15)}
          </span>
        )}
      </div>

      {!!tabData?.subTabs?.length && (
        <span
          data-open={isTabOpen}
          className={`w-5 h-5 focus:outline-none transition-transform duration-300 select-none data-[open=true]:rotate-180 `}
        >
          <ChevronDownIcon />
        </span>
      )}
    </Link>
  );
}

export default SideHref;
